import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from './authConfig.js';

import App from './App/App';
import reportWebVitals from './reportWebVitals.js';
////console.debug('process.env.REACT_APP_REDIRECT_URI', process.env.REACT_APP_REDIRECT_URI);

const pca = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <MsalProvider instance={pca}>
    <App />
  </MsalProvider>
);

reportWebVitals();
